import { render, staticRenderFns } from "./freePay.vue?vue&type=template&id=1d66a444&scoped=true"
import script from "./freePay.vue?vue&type=script&lang=js"
export * from "./freePay.vue?vue&type=script&lang=js"
import style0 from "./freePay.vue?vue&type=style&index=0&id=1d66a444&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d66a444",
  null
  
)

export default component.exports